/* eslint-disable @typescript-eslint/no-empty-function */

import { type Manifest } from '.';
import type * as A11yModule from './a11y';
import type * as DialogModule from './dialog';
import type * as FormProtectionModule from './form-protection';
import type * as TableModule from './table';
import type * as ValidatorsModule from './validators';
import { basePath } from '../utils/paths';

function shouldAutoCheckA11yStatement() {
    const a11yUrl = document.querySelector<HTMLMetaElement>('meta[name=deklaracja-dostępności]')?.content;
    const a11yAbsoluteUrl = a11yUrl ? new URL(a11yUrl, basePath).href : null;
    const currentURL = location.href.split('#')[0];
    return a11yAbsoluteUrl === currentURL;
}

export const a11yManifest: Manifest<typeof A11yModule> = {
    shouldAutoload(): boolean {
        return document.body.dataset.withToolboxA11y !== undefined || shouldAutoCheckA11yStatement();
    },
    load: () => import('./a11y'),
    onModuleLoaded(module) {
        if (shouldAutoCheckA11yStatement()) {
            const val = module.checkAccessibilityStatement();
            if (!val) {
                const pageBody: Optional<HTMLElement> = document.querySelector('main-panel > [slot=page-body]');
                if (pageBody) {
                    pageBody.style.outline = '2px solid var(--error)';
                    pageBody.style.outlineOffset = '4px';
                }
            }
        }
    },
};

export const dialogManifest: Manifest<typeof DialogModule> = {
    shouldAutoload(): boolean {
        return document.body.dataset.withToolboxDialog !== undefined;
    },
    load: () => import('./dialog'),
    onModuleLoaded() {},
};

export const formProtectionManifest: Manifest<typeof FormProtectionModule> = {
    shouldAutoload(): boolean {
        return document.body.dataset.withToolboxFormProtection !== undefined;
    },
    load: () => import('./form-protection'),
    onModuleLoaded() {},
};

export const validatorsManifest: Manifest<typeof ValidatorsModule> = {
    shouldAutoload(): boolean {
        return document.body.dataset.withToolboxValidators !== undefined;
    },
    load: () => import('./validators'),
    onModuleLoaded() {},
};

export const tableManifest: Manifest<typeof TableModule> = {
    shouldAutoload(): boolean {
        return document.body.dataset.withToolboxTable !== undefined;
    },
    load: () => import('./table'),
    onModuleLoaded() {},
};
